/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Whether the turns act for the user their event identified.
 */
export const SetExecutionProfileChoiceRequestBodyExecutionContext = {
  UserBacked: "user_backed",
  Userless: "userless",
} as const;
/**
 * Whether the turns act for the user their event identified.
 */
export type SetExecutionProfileChoiceRequestBodyExecutionContext = ClosedEnum<
  typeof SetExecutionProfileChoiceRequestBodyExecutionContext
>;

export type SetExecutionProfileChoiceRequestBody = {
  /**
   * The assistant ID.
   */
  assistantId: string;
  /**
   * The auth client to use.
   */
  authClientId?: string | undefined;
  /**
   * Remove the choice so the next turn makes it from the server's configuration.
   */
  automatic?: boolean | undefined;
  /**
   * Whether the turns act for the user their event identified.
   */
  executionContext: SetExecutionProfileChoiceRequestBodyExecutionContext;
  /**
   * The profile version the change was decided from, from a fresh listExecutionProfiles read. A profile that changed since is refused with a conflict.
   */
  expectedVersion: number;
  /**
   * The MCP server.
   */
  mcpServerId: string;
  /**
   * Use no upstream authentication.
   */
  noAuth?: boolean | undefined;
  /**
   * The root trigger.
   */
  triggerInstanceId: string;
};

/** @internal */
export const SetExecutionProfileChoiceRequestBodyExecutionContext$outboundSchema:
  z.ZodMiniEnum<typeof SetExecutionProfileChoiceRequestBodyExecutionContext> = z
    .enum(SetExecutionProfileChoiceRequestBodyExecutionContext);

/** @internal */
export type SetExecutionProfileChoiceRequestBody$Outbound = {
  assistant_id: string;
  auth_client_id?: string | undefined;
  automatic?: boolean | undefined;
  execution_context: string;
  expected_version: number;
  mcp_server_id: string;
  no_auth?: boolean | undefined;
  trigger_instance_id: string;
};

/** @internal */
export const SetExecutionProfileChoiceRequestBody$outboundSchema: z.ZodMiniType<
  SetExecutionProfileChoiceRequestBody$Outbound,
  SetExecutionProfileChoiceRequestBody
> = z.pipe(
  z.object({
    assistantId: z.string(),
    authClientId: z.optional(z.string()),
    automatic: z.optional(z.boolean()),
    executionContext:
      SetExecutionProfileChoiceRequestBodyExecutionContext$outboundSchema,
    expectedVersion: z.int(),
    mcpServerId: z.string(),
    noAuth: z.optional(z.boolean()),
    triggerInstanceId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      authClientId: "auth_client_id",
      executionContext: "execution_context",
      expectedVersion: "expected_version",
      mcpServerId: "mcp_server_id",
      noAuth: "no_auth",
      triggerInstanceId: "trigger_instance_id",
    });
  }),
);

export function setExecutionProfileChoiceRequestBodyToJSON(
  setExecutionProfileChoiceRequestBody: SetExecutionProfileChoiceRequestBody,
): string {
  return JSON.stringify(
    SetExecutionProfileChoiceRequestBody$outboundSchema.parse(
      setExecutionProfileChoiceRequestBody,
    ),
  );
}
